/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { AppBar, makeStyles } from '@material-ui/core';
import Button from 'components/common/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  ...theme.customTheme,
  bottomBar: {
    marginTop: 'auto',
    padding: '.25rem',
    top: 'unset',
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    color: theme.palette.footerText,
    backgroundColor: theme.palette.footerBackground,
    opacity: 0.95,
    [theme.breakpoints.between('xs', 'md')]: {
      width: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '100%',
    },
    [theme.breakpoints.between('lg', 'xl2')]: {
      width: '100%',
    },
    [theme.breakpoints.up('xl2')]: {
      width: '100%',
      paddingLeft: '3.5%',
      paddingRight: '3.5%',
    },
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  actionButton: {
    margin: '.25rem .75rem',
  },
}));

export default function OrganizationFormFooter({ onSave, disabled, editMode }) {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  return (
    <AppBar component="div" position="sticky" elevation={0} className={classes.bottomBar}>
      <div className={classes.toolbar}>
        <Button id="cancelButton" color="secondary" className={classes.actionButton} onClick={history.goBack}>
          {t('actions.cancel')}
        </Button>
        <Button id="newOrganizationButton" color="primary" disabled={disabled} onClick={onSave}>
          {editMode ? t('user.management.edit.organization') : t('user.management.create-organization')}
        </Button>
      </div>
    </AppBar>
  );
}
